// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__nSk4g","col":"CardReaderDesc_col__3CYc3","label":"CardReaderDesc_label__95NKN"};